var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"hp-card-4 hp-chart-text-color"},[_c('h4',[_vm._v("Analytic")]),_c('div',{staticClass:"overflow-hidden",attrs:{"id":"revenue-column-card"}},[_c('apexchart',{attrs:{"type":"bar","height":"303","legend":"legend","options":_vm.options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }